import { EDocMetadata, EDocMetadataProps } from '@/components/EDocMetadata';
import { IconClose } from '@moneyforward/ap-frontend-components';
import classNames from 'classnames';
import { FC, memo, useMemo } from 'react';
import styles from '../Details.module.scss';

const cx = classNames.bind(styles);

export type InnerDetailsProps = {
  onClose: VoidFunction;
} & EDocMetadataProps;

export const InnerDetails: FC<InnerDetailsProps> = memo(
  ({
    dpi,
    pixelNumber,
    imageDepth,
    type,
    isScan,
    isSatisfyResolutionRequirement,
    isSatisfyDepthRequirements,
    onClose,
  }) => {
    const leftRightRatio = useMemo(
      () => ({
        left: {
          max: '160px',
          min: '160px',
        },
        right: {
          max: '236px',
          min: '236px',
        },
      }),
      []
    );

    return (
      <div className={cx(styles['container'])}>
        <button onClick={onClose} className={cx(styles['icon'])}>
          <IconClose size={18} />
        </button>
        <div className={cx(styles['list'])}>
          <EDocMetadata
            dpi={dpi}
            pixelNumber={pixelNumber}
            imageDepth={imageDepth}
            type={type}
            isScan={isScan}
            isSatisfyResolutionRequirement={isSatisfyResolutionRequirement}
            isSatisfyDepthRequirements={isSatisfyDepthRequirements}
            leftRightRatio={leftRightRatio}
          />
        </div>
      </div>
    );
  }
);
InnerDetails.displayName = 'InnerDetails';
